import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import WangEditor from '@gp/components/WangEditor';
import '@gp/components/AutoTextarea/index.scss';

type AutoTextareaPropsType = {
  // 默认值
  defaultValue?: string;
  readOnly?: boolean;
  maxLength?: number;
  // 文本内容改变，只包含纯text文本
  onChange?: (value: string) => void;
  // 文本内容改变，包含富文本
  onChangePlus?: (value: string) => void;
  placeholder?: string;
  className?: string;
  style?: React.CSSProperties;
  [key: string]: any;
};

const AutoTextarea: React.FC<AutoTextareaPropsType> = (props) => {
  const {
    defaultValue,
    readOnly = false,
    maxLength,
    onChange,
    onChangePlus,
    className,
    style,
    placeholder = 'Please enter information',
    ...remains
  } = props;

  const [isFocus, setIsFocus] = useState<boolean>(false);

  const handleChange = useCallback(
    (value: string) => {
      if (onChange instanceof Function) {
        onChange(value);
      }
    },
    [onChange],
  );

  const handleChangePlus = useCallback(
    (value: string) => {
      if (onChangePlus instanceof Function) {
        onChangePlus(value);
      }
    },
    [onChangePlus],
  );

  return (
    <div
      style={style}
      className={classnames({
        'dbg-autotextarea gp-inital-list-style': true,
        [className as string]: !!className,
        'is-Focus-editor': isFocus,
        'dbg-autotextarea-readOnly':readOnly
      })}
    >
      <WangEditor
        {...remains}
        className="dbg-autotextarea-editor"
        autoFocus={false}
        readOnly={readOnly}
        maxLength={maxLength}
        isShowToolbar={false}
        defaultValue={defaultValue}
        getEditorText={handleChange}
        getEditorContent={handleChangePlus}
        placeholder={placeholder}
        getIsFocused={(v: boolean) => setIsFocus(v)}
      />
    </div>
  );
};

export default React.memo(AutoTextarea);
